import React from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";
import crossImage from "../../images/icons/cross.png";

const CancelPopUp = ({
  title,
  storeName,
  close,
  performAction,
  isOffice = false,
  turneroEnabled = false,
}) => {
  const {t} = useTranslation();
  return (
    <div className="cancel-box-container">
      <div className="cancel-box-inner-container">
        {title ? (
          <div className={"cancel-box-title-div"}>
            <h4 className="cancel-box-title-text">{title}</h4>
            <img src={crossImage} alt="X" onClick={close} />
          </div>
        ) : (
          ""
        )}

        <div className="cancel-box-text-container">
          <label className="cancel-box-text">
            {t("cancelText")}
            {isOffice
              ? `reserva en  ${storeName} `
              : turneroEnabled
              ? t("turn")
              : `reserva`}
            {" ?"}
          </label>
        </div>

        <div className="cancel-box-btn" onClick={performAction}>
          {title}
        </div>
      </div>
    </div>
  );
};

export default CancelPopUp;
